
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import es_ES from 'antd/lib/locale/es_ES'

import AppRouter from "./router/AppRouter";
import './App.css';

function App() {
  return (
    <ConfigProvider locale={ es_ES }>
      <BrowserRouter>
        <AppRouter/>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
